export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'button',
		label: 'Button',
		selector: '& .button'
	},
	{
		name: 'icon',
		label: 'Icon',
		selector: '& .icon'
	},
	{
		name: 'text',
		label: 'Text',
		selector: '& .text'
	},
	{
		name: 'subtext',
		label: 'Subtext',
		selector: '& .subtext'
	}
]